import { getInstance } from 'recaptcha-v3';

export async function getRecaptchaToken(action: string) {
  const token = await getInstance().execute(action);

  return token;
}
